var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 20.0001C39.9998 31.0457 31.0454 40.0001 19.9998 40.0001C8.95413 40.0001 -0.000244141 31.0457 -0.000244141 20.0001C-0.000244141 20.0049 19.9998 0.00230957 19.9998 0.00012207C31.0454 0.00012207 39.9998 8.9545 39.9998 20.0001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 9.56537V16.3109L13.0432 9.56537H19.9997Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 20.0002H16.3105L10.4346 12.1741L9.56506 18.261L10.4346 20.0002Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9464 20.0001H19.9999C19.9999 19.9821 19.9999 19.9646 19.9999 19.9466C19.9821 19.9645 19.9643 19.9823 19.9464 20.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 10.4348C19.9999 6.91569 19.9999 4.60983 19.9999 6.10352e-05H19.9965C8.95238 0.00193604 -0.00012207 8.95545 -0.00012207 20.0001H10.4346V14.1242L16.3106 20.0001H19.9465C19.9643 19.9822 19.9821 19.9644 20 19.9465C20 18.5991 20 17.3969 20 16.3108L14.1239 10.4348H19.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1183 2.6087C6.99028 4.38988 4.38981 6.99034 2.60864 10.1184V20H7.82606V7.82628V7.82613H20C20 6.18058 20 4.61292 20 2.6087H10.1183Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5406L12.8943 10.4349H10.4348V10.435L19.9998 20H20C20 20 20 18.3042 20 17.5406Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6085 13.0436V20C22.6085 24.6594 28.6955 26.087 28.6955 26.087C28.6955 26.087 34.7824 24.6594 34.7824 20V13.0436L28.6955 11.3044L22.6085 13.0436Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7824 13.0436V10.4349H22.6085V13.0436H27.8258V18.2611H22.6085V20.0001V20.0003L27.8258 20.0003V25.8204C28.3506 26.006 28.6955 26.0871 28.6955 26.0871C28.6955 26.0871 29.0402 26.0062 29.5649 25.8204V20.0003H34.7824V20.0001V18.261H29.5649V13.0435H34.7824V13.0436Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiji);
export default __webpack_public_path__ + "static/media/fiji.a177c8a7c4b7a7bf842e22244b4ec07e.svg";
export { ForwardRef as ReactComponent };